import { complement, pathEq } from 'ramda';
import React, { useState, useEffect } from 'react';

import { Icon } from '@ui/icons/Icon.tsx';

import { useCSSColors } from '../../../../src/hooks/useCSSColors.ts';
import {
  ShowOtherResultsBannerWrapper,
  ShowOtherResultsBanner,
  BannerLabel,
  OtherResultsIndicatorBanner,
  BannerIconWrapper,
} from './styles.ts';

export const ResultsOnOtherFloorsBanner = ({ widgetState, bus }) => {
  const colors = useCSSColors();
  const [isVisible, setIsVisible] = useState(areResultsOnOtherFloorsOrBuildings(widgetState.getState()));

  useEffect(() => {
    const isVisible = areResultsOnOtherFloorsOrBuildings(widgetState.getState());
    setIsVisible(isVisible);
  }, [widgetState.getState().searchResults]);

  useEffect(() => {
    const unsub = bus.on('map/userMoveStart', () => setIsVisible(false));
    return unsub;
  }, []);

  const onBannerClicked = () => {
    bus.send('mapLevelSelectorOnline/openLevelSelector');
    setIsVisible(false);
  };

  // todo add text Results on other levels to i18n
  return isVisible ? (
    <ShowOtherResultsBannerWrapper data-testid="resultsOnOtherFloorsBanner">
      <ShowOtherResultsBanner onClick={onBannerClicked}>
        <BannerIconWrapper>
          <Icon cdn name="levels" width={32} height={32} fillColor={colors.primaryText} />
          <OtherResultsIndicatorBanner />
        </BannerIconWrapper>
        <BannerLabel>Results on other levels</BannerLabel>
      </ShowOtherResultsBanner>
    </ShowOtherResultsBannerWrapper>
  ) : null;
};

function areResultsOnOtherFloorsOrBuildings({ selectedBuilding, selectedLevel, searchResults }) {
  const anyDifferent = (path, value) => searchResults.some(complement(pathEq(value, path)));
  if (selectedLevel) {
    return anyDifferent(['position', 'floorId'], selectedLevel.id);
  }
  if (selectedBuilding) {
    return anyDifferent(['position', 'buildingId'], selectedBuilding.id);
  }
}
